const json = {
 "logoPosition": "right",
 "pages": [
  {
   "name": "page1",
   "elements": [
    {
     "type": "text",
     "name": "email",
     "title": {
      "default": "Email",
      "lt": "E-paštas"
     },
     "titleLocation": "top",
     "hideNumber": true,
     "isRequired": true,
     "requiredErrorText": {
      "default": "Provide your email",
      "lt": "Nurodykite jūsų el,paštą"
     },
     "inputType": "email",
     "autocomplete": "email",
     "placeholder": {
      "default": "jon.doe@example.com",
      "lt": "jonas.jonaitis@example.com"
     }
    }
   ]
  }
 ]
}